import { makeAutoObservable, runInAction } from 'mobx';

type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;

interface Alert {
  severity: 'error' | 'warning' | 'info' | 'success';
  message: string;
  duration: number;
}

class AlertStore {
  alertQueue: Alert[] = [];

  activeAlert: Alert | null = null;

  activeAlertTimeout: NodeJS.Timeout | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  pushAlert(alert: Optional<Alert, 'duration'>): void {
    this.alertQueue.push({
      duration: 5000,
      ...alert,
    });

    if (!this.activeAlert) {
      this.showNextAlert();
    }
  }

  showNextAlert(): void {
    const alert = this.alertQueue.shift();

    if (alert) {
      this.activeAlert = alert;
      this.activeAlertTimeout = setTimeout(() => {
        runInAction(() => {
          this.activeAlert = null;
        });
        this.showNextAlert();
      }, alert.duration);
    }
  }
}

export default AlertStore;
